import { FormState } from "./FormState";
import {
  CanalMarketing,
  crearPropietario,
  NuevoPropietario,
  RespuestaCrearPropietario,
  TipoDocumento,
} from "../../../services/propietariosServicios";

const generarNuevoPropietario = (formState: FormState): NuevoPropietario => {
  let canal: CanalMarketing | undefined = undefined;

  if (formState.canalMarketing.value) {
    canal = formState.canalMarketing.value as CanalMarketing;
  }

  return {
    primerNombre: formState.primerNombre.value,
    segundoNombre: formState.segundoNombre.value,
    primerApellido: formState.primerApellido.value,
    segundoApellido: formState.segundoApellido.value,
    contrato: formState.contrato.value,
    firma: formState.firma.value,
    tipoDocumento: formState.tipoDocumento.value as TipoDocumento,
    documento: formState.documento.value,
    ciudadExpedicion: formState.ciudadExpedicion.value,
    email: formState.email.value,
    celular: formState.celular.value,
    nombresContactoAlterno: formState.nombresContactoAlterno.value,
    celularContactoAlterno: formState.celularContactoAlterno.value,
    direccionResidencia: formState.direccionResidencia.value,
    idSectorResidencia: formState.sectorResidencia.value,
    canalMarketing: canal,
    esTurista: formState.esTurista.value,
    idPaisProveniencia: formState.paisProveniencia.value,
    idCiudadProveniencia: formState.ciudadProveniencia.value,
    fechaNacimiento: formState.fechaNacimiento.value,
  };
};

export const crearNuevoPropietario = async (
  formState: FormState
): Promise<RespuestaCrearPropietario> => {
  const nuevoPropietario = generarNuevoPropietario(formState);
  return await crearPropietario(nuevoPropietario);
};
